import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomSwitch from "../../components/custom-ui/CustomSwitch.jsx";
import apisecured from "../../api/apisecured.js";
import { toast } from "react-toastify";
import { setNotificationPreferences } from "../../State/authSlicer.js";

function NotificationSetting() {
  const dispatch = useDispatch();
  const ReceiveAllTips = useSelector((state) => state.auth.ReceiveAllTips);
  const ReceiveGoalFunded = useSelector(
    (state) => state.auth.ReceiveGoalFunded
  );
  useEffect(() => {
    if (ReceiveAllTips === null || ReceiveGoalFunded === null) {
      const fetchNotificationPreferences = async () => {
        try {
          const response = await apisecured.get(
            "account/get-notification-preferences"
          );
          // ✅ Store in Redux
          dispatch(
            setNotificationPreferences({
              ReceiveAllTips: response.data.receiveAllTips,
              ReceiveGoalFunded: response.data.receiveGoalFunded,
            })
          );
        } catch (error) {
          console.error("Error fetching notification preferences:", error);
          toast.error("Failed to load notification settings.");
        }
      };

      fetchNotificationPreferences();
    }
  }, [ReceiveAllTips, ReceiveGoalFunded, dispatch]); // ✅ Only runs if state is empty
  // Function to handle switch toggle
  const handleToggle = async (field) => {
    const newValue =
      field === "ReceiveAllTips" ? !ReceiveAllTips : !ReceiveGoalFunded;

    // ✅ Update Redux state immediately (optimistic update)
    dispatch(setNotificationPreferences({ [field]: newValue }));

    try {
      await apisecured.post("account/update-notification-preference", {
        [field]: newValue,
      });
      toast.success("Notification settings updated.");
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Failed to update notification settings.");
      dispatch(setNotificationPreferences({ [field]: !newValue }));
    }
  };

  return (
    <>
      <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold !text-left "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          General
        </h2>

        <h2 className="CustomSignUpLabel !font-medium !ml-0 mt-6">
          Select the notifications you would like to receive on SPONSA
        </h2>

        <div className="rounded-xl  bg-[#030021]  ">
          <div className="rounded-xl  bg-[#35334D99] space-y-6 p-6 mt-4 ">
            <div className="flex items-center gap-3 text-white  ">
              <CustomSwitch
                isActive={ReceiveAllTips}
                onClick={() => handleToggle("ReceiveAllTips")}
              />
              <div>
                <p
                  className="text-white font-bold"
                  style={{ fontFamily: "Gilroy", fontWeight: "700" }}
                >
                  Tips
                </p>
                <p className="text-gray-300 text-sm font-medium">
                  Notify me for all tips made
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 text-white  ">
              <CustomSwitch
                isActive={ReceiveGoalFunded}
                onClick={() => handleToggle("ReceiveGoalFunded")}
              />
              <div>
                <p
                  className="text-white font-bold"
                  style={{ fontFamily: "Gilroy", fontWeight: "700" }}
                >
                  Goals
                </p>
                <p className="text-gray-300 text-sm font-medium">
                  Notify me when a goal is fully funded
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold !text-left "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          Email
        </h2>

        <h2 className="CustomSignUpLabel !font-medium  !text-left  !ml-0 mt-3  ">
          Select the notifications you would like to receive via email{" "}
        </h2>

        <div className="rounded-xl  bg-[#030021]  ">
          <div className="rounded-xl  bg-[#35334D99] space-y-6 p-6 mt-4 ">
            <div className="flex  gap-3 text-white  ">
              <CustomSwitch isActive={true} />
              <div>
                <p  className="text-white font-bold"
                    style={{ fontFamily: "Gilroy", fontWeight: "700" }}">
                  Tips
                </p>
                <p className="font-normal text-[15px] leading-[100%] tracking-[0%]  ">
                  Notify me for all tips made
                </p>
              </div>
            </div>
            <div className="flex  gap-3 text-white  ">
              <CustomSwitch isActive={true} />
              <div>
                <p  className="text-white font-bold"
                    style={{ fontFamily: "Gilroy", fontWeight: "700" }}">
                  Goals
                </p>
                <p className="font-normal text-[15px] leading-[100%] tracking-[0%]  ">
                  Notify me when a goal is fully funded
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className=" text-[15px] leading-[100%] tracking-[0%]  font-normal text-center mt-4 text-white  ">
          Your emails are sent to{" "}
          <Link
            to={"mailto:officialvelocityyt@gmail.com"}
            className=" LinkUnderline font-semibold    "
          >
            officialvelocityyt@gmail.com
          </Link>
        </div>
      </div> */}
    </>
  );
}

export default NotificationSetting;
